const paymentFormStyles = (theme) => ({
    button: {
      marginTop: 2,
      padding: "10px 20px",
      fontWeight: 600,
      fontSize: "1rem",
      borderRadius: 2,
      transition: "0.3s",
      fontFamily: '"Roboto", "Arial", sans-serif', // Пример добавления шрифта
      "&:hover": {
        backgroundColor: theme.palette.mode === "light" ? theme.palette.primary.dark : theme.palette.primary.light,
        boxShadow: 3,
      },
      backgroundColor: theme.palette.mode === "light" ? theme.palette.primary.main : theme.palette.primary.dark,
      color: theme.palette.mode === "light" ? "#fff" : "#000",
    },
  });
  
  export default paymentFormStyles;
  